export const envStrict = (key) => {
    if (key in process.env) {
        return process.env[key];
    }
    throw new Error(`Missing env '${key}'.`);
};
export const env = (key, def) => {
    return key in process.env ? process.env[key] : def;
};
